/**
 * @enum {number} UploadTypeConst
 * @description 上传类型
 */
export const enum UploadTypeConst {
  /** 游戏包 */
  GamePackage = 1,
  /** 税务登记证 */
  TaxRegistrationCertificate = 151,
  /** 营业执照图片 */
  BusinessLicense = 152,
  /** 开发者身份证 */
  DeveloperIdCard = 153,
  /** 开放平台预约素材五图 */
  OpenPlatformMaterialFivePic = 154,
  /** 开放平台预约素材视频 */
  OpenPlatformMaterialVideo = 155,
  /** 游戏自助审核反馈文件 */
  GameSelfAuditFeedbackFile = 157,
  /** 厂商游戏评审包 */
  GameReviewPackage = 161,
  /** 评审游戏运营数据文件 */
  GameOperationDataFile = 162,
  /** 资质评审版号授权链数据 */
  QualificationReviewAuthorizationChainData = 163,
  /** 资质评审软著授权链数据 */
  QualificationReviewSoftwareAuthorizationChainData = 164,
  /** 资质评审IP文件 */
  QualificationReviewIPFile = 165,
  /** 游戏资质评审软件著作权证书 */
  QualificationReviewSoftwareCertificate = 166,
  /** 游戏初审申请资料*/
  GamePreliminaryReviewApplicationMaterials = 167,
  /** 开放平台游戏icon*/
  OpenPlatformGameIcon = 178,
  /** 开放平台视频封面 */
  OpenPlatformVideoCover = 179,
  /** 游戏资质评审ISBN版号文件*/
  QualificationReviewISBNVersionFile = 181,
  /** 申诉说明文件 */
  AppealFile = 207,
  /** 游戏自助审核反馈文件-安装包 */
  GameSelfAuditFeedbackFileInstallPackage = 280,
  /** 开放平台国际版 - 公司注册资料（香港地址为商业登记证图片）*/
  InternationalCompanyRegistration = 293,
  /** 开放平台国际版 - 申诉说明文件 */
  InternationalAppealFile = 294,
  /** 开放平台竖版视频 */
  OpenPlatformVerticalVideo = 300,
  /** 开放平台竖版视频封面 */
  OpenPlatformVerticalVideoCover = 301
}

/**
 * @enum {number} UploadPurposeIdConst
 * @description 上传用途ID
 */
export const enum UploadPurposeIdConst {
  /** 游戏包 */
  GamePackageUpload = 1,
  /** 后台图片上传 */
  BackgroundImageUpload = 2,
  /** 客户端图片上传 */
  ClientImageUpload = 3,
  /** 客户端视频上传 */
  ClientVideoUpload = 5,
  /** 后台其它文件上传 */
  BackgroundOtherFileUpload = 6,
  /** 通用游戏包上传 */
  CommonGamePackageUpload = 7
}
